import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('action_needed_migrate_to_editing_on_approval'),
    discontinuedDescription: defineMessage('the_old_reviewer_featur_bdiscontinued_on_july_b'),
    migrationDescription: defineMessage('to_keep_your_review_cap_e_new_url_feature_today'),
    migrationDescriptionLink: defineMessage('editing_on_approval'),
    importantDescription: defineMessage('icon_importantbrthe_old_approval_manually_later'),
    role: defineMessage('role'),
    migrationResults: defineMessage('migration_results'),
    approverAndReviewer: defineMessage('bapprover_and_reviewerb'),
    onlyReviewerAndNotApprover: defineMessage('only_breviewer_and_not_approverb'),
    approverAndReviewerMigrationResult1: defineMessage('can_edit_bdescription_q__amount_and_attachmentb'),
    approverAndReviewerMigrationResult2: defineMessage('can_edit_bitem_accounts_not_marked_as_readonlyb'),
    approverAndReviewerMigrationResult3: defineMessage('can_set_values_bwith_sa_nd_tracking_categoriesb'),
    onlyReviewerAndNotApproverMigrationResult: defineMessage('no_editing_permissions__ned_editing_permissions'),
    noReviewersDescription: defineMessage('no_reviewers_are_set_no_migration_is_required'),
    warning: defineMessage('irreversible_change_onc_he_old_reviewer_feature'),
    countReviewersDescription: defineMessage('count_reviewers_will_au__to_editing_on_approval'),
    irreversibleDescription: defineMessage('irreversible_change_onc_he_old_reviewer_feature'),
    doYouWantToReplaceOldReviewerByEditingOnApproval: defineMessage('would_you_like_to_migra_re_uninterrupted_access'),
    yes: defineMessage('yes_migrate_now'),
    no: defineMessage('skip_for_now'),
};
